/** @format */

import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ReactComponent as DeleteOption } from "../../../assets/DeleteOption.svg";
import { ReactComponent as SortIcon } from "../../../assets/sort.svg";

const MultipleChoiceTemplate = ({ setSurvey, questionIndex, optionRequestDTOS, name, answerLength }) => (
  <>
    <div className='field'>
      <InputText
        value={name}
        placeholder="Enter Question"
        onChange={(e) => {
          let value = e.target.value;
          setSurvey((draft) => {
            let currentQuestion = draft.questionRequestDTOS[questionIndex];
            currentQuestion.name = value;
          });
        }}
      />
    </div>
    <DragDropContext
      onDragEnd={(result) => {
        let startIndex = result.source && result.source.index;
        let endIndex = result.destination && result.destination.index;
        setSurvey((draft) => {
          if (startIndex && endIndex) {
            let currentQuestion = draft.questionRequestDTOS[questionIndex];
            const [removed] = currentQuestion.optionRequestDTOS.splice(startIndex, 1);
            currentQuestion.optionRequestDTOS.splice(endIndex, 0, removed);
          }
        });
      }}
    >
      <Droppable droppableId='answer-droppable'>
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {optionRequestDTOS?.map((answer, answerIndex) => (
              <Draggable key={`draggable-${answerIndex}`} draggableId={`draggable-${answerIndex}`} index={answerIndex}>
                {(provided, snapshot) => (
                  <span className='p-input-icon-right mt-3' ref={provided.innerRef} {...provided.draggableProps}>
                    <RadioButton value='' name='' checked={false} disabled />

                    <DeleteOption
                      disabled={answerLength === 1}
                      style={{
                        cursor: answerLength === 1 ? "not-allowed" : "pointer",
                        opacity: answerLength === 1 ? "0.5" : "1",
                      }}
                      onClick={(e) => {
                        if (answerLength === 1) return;
                        setSurvey((draft) => {
                          let currentQuestion = draft.questionRequestDTOS[questionIndex];
                          currentQuestion.optionRequestDTOS.splice(answerIndex, 1);
                        });
                      }}
                    />
                    <div {...provided.dragHandleProps} className='svg__wrapper sort'>
                      <SortIcon />
                    </div>
                    <InputText
                      placeholder="Enter Option"
                      value={answer.option}
                      onChange={(e) => {
                        let value = e.target.value;
                        setSurvey((draft) => {
                          let currentQuestion = draft.questionRequestDTOS[questionIndex];
                          currentQuestion.optionRequestDTOS[answerIndex] = {
                            option: value,
                          };
                        });
                      }}
                    />
                  </span>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  </>
);

MultipleChoiceTemplate.AddOptions = ({ answerLength, setSurvey, questionIndex }) => {
  return (
    <div className='survey__add__option'>
      <span>
        Add{" "}
        <a
          href='#option'
          disabled={answerLength === 5}
          style={{
            cursor: answerLength === 5 ? "not-allowed" : "pointer",
            opacity: answerLength === 5 ? "0.5" : "1",
          }}
          onClick={(e) => {
            e.preventDefault();
            if (answerLength === 5) return;
            setSurvey((draft) => {
              let currentQuestion = draft.questionRequestDTOS[questionIndex];
              currentQuestion.optionRequestDTOS.push({
                option: "",
              });
            });
          }}
        >
          Option
        </a>
      </span>
      <p className='p-my-0'>
        <i>
          <sup>*</sup>Maximum of 5 Answers
        </i>
      </p>
    </div>
  );
};
export default MultipleChoiceTemplate;
